// src/components/ProtectedRoute.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'flowbite-react'; // Assuming you have flowbite-react installed
import { checkAuth } from '../services/authService';

const ProtectedRoute = ({ children ,allowedRoles, redirectTo = '/' }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null); // null means checking, true means authenticated, false means not
   const [user,setUser] =  useState({});
    const navigate = useNavigate();

    useEffect(() => {
        const verifyAuth = async () => {
            const fetchedUser = await checkAuth(); // Call your robust checkAuth function
            console.log("fetched user",fetchedUser);
            if (fetchedUser) {
                setUser(fetchedUser);
                setIsAuthenticated(true);


            } else {
                setIsAuthenticated(false);
                navigate('/'); // Redirect to the login page if not authenticated
            }
        };

        verifyAuth();
    }, [navigate]); // `Maps` should be in the dependency array for useEffect

    // While checking authentication, show a loading spinner
    if (isAuthenticated === null) {
        return (
            <div className="flex justify-center items-center min-h-screen bg-gray-100 dark:bg-gray-900">
                <Spinner size="xl" color="purple" />
            </div>
        );
    }

    // If isAuthenticated is true, render the children (the protected content)
    // If isAuthenticated is false, the navigate() call in useEffect will handle the redirection,
    // so we return null or an empty fragment to prevent rendering the protected content momentarily.
    return isAuthenticated ?children: null;
};

export default ProtectedRoute;